import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { updateAreaOfConcern } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateAreaOfConcern = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const { t } = useTranslation(["clientDetails"]);

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, id, payload }: { clientId: number; id: number; payload: Record<string, any> }) =>
      updateAreaOfConcern(clientId, id, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: t("clientDetails:areasOfConcern.updateSuccess") });
        onSuccess(response, variables);
      },
      onError: (error: any, variables, context) => {
        const message =
          error?.response?.status === 403
            ? t("clientDetails:areasOfConcern.updateErrorForbidden")
            : t("clientDetails:areasOfConcern.updateErrorGeneric");
        showToast({ message, errorState: true });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    updateAreaOfConcernMutation: mutate,
    isUpdateAreaOfConcernLoading: isLoading,
    ...rest,
  };
};

export default useUpdateAreaOfConcern;
